import { RowNode } from '@ag-grid-community/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-financials-status-bar',
  templateUrl: './financials-status-bar.component.html',
  styleUrls: ['./financials-status-bar.component.scss']
})
export class FinancialsStatusBarComponent implements OnInit,OnDestroy {
  private destroy$ = new Subject<void>();
  private params: any;
  constructor() { }

  agInit(params: any): void {
    this.params = params;
  }

  ngOnInit(): void {
  }

  total: any = () => {
    let amount: number = 0;
    this.params.api.forEachNode((node: RowNode) => {
      amount += node?.data?.amount ?? 0;
    });
    return amount;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
